import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import NumberCircle from "./NumberCirlcle";
import trashIcon from "../resources/trashcan.svg";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { ShepherdTourContext } from "../lib/shepherd";
import { createOnChangeHandler } from "../lib/helpers";
import pencil from "../resources/pencil.svg";

export const DragAndDropQuestion = ({
  id,
  text,
  questionNumber,
  handleDelete,
  updateQuestionText,
}: {
  id: number;
  text: string;
  questionNumber: number;
  handleDelete: (index: number) => () => void;
  updateQuestionText: (index: number, newQuestionText: string) => void;
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const shepherd = useContext(ShepherdTourContext);

  const [isBeingEditted, setIsBeingEditted] = useState<boolean>(false);

  const [questionTextCache, setQuestionTextCache] = useState<string>(text);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isBeingEditted) {
      setQuestionTextCache(text);
      inputRef.current?.focus();
    }
  }, [isBeingEditted]);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: "flex",
    justifyContent: "start",
    marginBottom: "1rem",
    alignItems: "center",
  };

  const safeHandleDelete = (index: number) => () => {
    if (
      shepherd.isActive() &&
      shepherd.currentStep?.id === "Delete Questions"
    ) {
      shepherd.next();
    }
    handleDelete(index)();
  };

  const onBlur = () => {
    updateQuestionText(questionNumber, questionTextCache);
    setIsBeingEditted(false);
  };

  const onChange = createOnChangeHandler(setQuestionTextCache);

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <NumberCircle number={questionNumber + 1} color="#2EB3C8" />
      {isBeingEditted ? (
        <input
          ref={inputRef}
          value={questionTextCache}
          onChange={onChange}
          onBlur={onBlur}
          style={{
            borderRadius: 24,
            backgroundColor: "#F7F7F7",
            paddingBottom: ".5rem",
            paddingTop: ".5rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            marginLeft: ".5rem",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* <div
            onClick={safeHandleDelete(questionNumber)}
            style={{ flexShrink: 0 }}
          >
            <img src={trashIcon} className={`trashCan`} />
          </div> */}
        </input>
      ) : (
        <div
          onDoubleClick={() => setIsBeingEditted(true)}
          style={{
            borderRadius: 24,
            backgroundColor: "#F7F7F7",
            paddingBottom: ".5rem",
            paddingTop: ".5rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
            marginLeft: ".5rem",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>{text}</span>
          <div style={{display: 'flex', gap: '1rem'}}>
          <div
            onClick={() => setIsBeingEditted(true)}
            style={{ flexShrink: 0 }}
          >
            <img src={pencil} className={`trashCan`} />
          </div>
          <div
            onClick={safeHandleDelete(questionNumber)}
            style={{ flexShrink: 0 }}
          >
            <img src={trashIcon} className={`trashCan`} />
          </div>
          </div>
        </div>
      )}
    </div>
  );
};
